export default __webpack_public_path__ + "static/media/WhitePlus.5006311c.svg";